import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import e from "../core/Plugin";

var t = /*#__PURE__*/function (_e) {
  _inherits(t, _e);

  var _super = _createSuper(t);

  function t(e) {
    var _this;

    _classCallCheck(this, t);

    _this = _super.call(this, e);
    _this.statuses = new Map();
    _this.opts = Object.assign({}, {
      onStatusChanged: function onStatusChanged() {}
    }, e);
    _this.elementValidatingHandler = _this.onElementValidating.bind(_assertThisInitialized(_this));
    _this.elementValidatedHandler = _this.onElementValidated.bind(_assertThisInitialized(_this));
    _this.elementNotValidatedHandler = _this.onElementNotValidated.bind(_assertThisInitialized(_this));
    _this.elementIgnoredHandler = _this.onElementIgnored.bind(_assertThisInitialized(_this));
    _this.fieldAddedHandler = _this.onFieldAdded.bind(_assertThisInitialized(_this));
    _this.fieldRemovedHandler = _this.onFieldRemoved.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(t, [{
    key: "install",
    value: function install() {
      this.core.on("core.element.validating", this.elementValidatingHandler).on("core.element.validated", this.elementValidatedHandler).on("core.element.notvalidated", this.elementNotValidatedHandler).on("core.element.ignored", this.elementIgnoredHandler).on("core.field.added", this.fieldAddedHandler).on("core.field.removed", this.fieldRemovedHandler);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.statuses.clear();
      this.core.off("core.element.validating", this.elementValidatingHandler).off("core.element.validated", this.elementValidatedHandler).off("core.element.notvalidated", this.elementNotValidatedHandler).off("core.element.ignored", this.elementIgnoredHandler).off("core.field.added", this.fieldAddedHandler).off("core.field.removed", this.fieldRemovedHandler);
    }
  }, {
    key: "areFieldsValid",
    value: function areFieldsValid() {
      return Array.from(this.statuses.values()).every(function (e) {
        return e === "Valid" || e === "NotValidated" || e === "Ignored";
      });
    }
  }, {
    key: "getStatuses",
    value: function getStatuses() {
      return this.statuses;
    }
  }, {
    key: "onFieldAdded",
    value: function onFieldAdded(e) {
      this.statuses.set(e.field, "NotValidated");
    }
  }, {
    key: "onFieldRemoved",
    value: function onFieldRemoved(e) {
      if (this.statuses.has(e.field)) {
        this.statuses.delete(e.field);
      }

      this.opts.onStatusChanged(this.areFieldsValid());
    }
  }, {
    key: "onElementValidating",
    value: function onElementValidating(e) {
      this.statuses.set(e.field, "Validating");
      this.opts.onStatusChanged(false);
    }
  }, {
    key: "onElementValidated",
    value: function onElementValidated(e) {
      this.statuses.set(e.field, e.valid ? "Valid" : "Invalid");

      if (e.valid) {
        this.opts.onStatusChanged(this.areFieldsValid());
      } else {
        this.opts.onStatusChanged(false);
      }
    }
  }, {
    key: "onElementNotValidated",
    value: function onElementNotValidated(e) {
      this.statuses.set(e.field, "NotValidated");
      this.opts.onStatusChanged(false);
    }
  }, {
    key: "onElementIgnored",
    value: function onElementIgnored(e) {
      this.statuses.set(e.field, "Ignored");
      this.opts.onStatusChanged(this.areFieldsValid());
    }
  }]);

  return t;
}(e);

export { t as default };